// auth
export const LOGOUT = 'LOGOUT'
export const UPDATE_AUTH = 'UPDATE_AUTH'
export const UPDATE_USER = 'UPDATE_USER'

// Configs
export const UPDATE_SOCIETIES = 'UPDATE_SOCIETIES'
export const UPDATE_ROLES = 'UPDATE_ROLES'
export const UPDATE_SERVER_STATUS = 'UPDATE_SERVER_STATUS'
